import {
	ActionStates,
	FileInfoType,
	OnboardingUserAppErrorType,
	SupportedProfilePictureAction,
	UserInfoType,
} from '../types/ActionTypes'
import { type Config } from '@adsk/napi-config'
import { GetSelectionListByNameResult } from '@adsk/napi-api-client/src/types'

export const setUserInfoChanged = (userInfoChanged: boolean) => {
	return {
		type: ActionStates.SET_USER_INFO_CHANGED,
		payload: userInfoChanged,
	}
}

export const setImmutableUserInfo = (userInfo: UserInfoType) => {
	return {
		type: ActionStates.SET_IMMUTABLE_USER_INFO,
		payload: userInfo,
	}
}
export const setSelectionsList = (payload: GetSelectionListByNameResult[]) => {
	return {
		type: ActionStates.SET_SELECTIONS_LIST,
		payload: payload,
	}
}
export const setUserInfo = (userInfo: UserInfoType) => {
	return {
		type: ActionStates.SET_USER_INFO,
		payload: userInfo,
	}
}

export const setFlowType = (payload: string) => {
	return {
		type: ActionStates.SET_FLOW_TYPE,
		payload,
	}
}

export const toggleReadOnlyMode = () => {
	return {
		type: ActionStates.TOGGLE_PROFILE_READ_ONLY_MODE,
	}
}

export const showLoadingState = (isEnabled: boolean) => {
	return {
		type: ActionStates.SHOW_LOADER,
		payload: isEnabled,
	}
}

export const setErrorInfo = (error: OnboardingUserAppErrorType) => {
	return {
		type: ActionStates.SET_ERROR_INFO,
		payload: error,
	}
}

export const resetState = () => {
	return {
		type: ActionStates.RESET_STATE,
	}
}

export const resetCurrentAvatarSelectionState = () => {
	return {
		type: ActionStates.RESET_AVATAR_CURRENT_SELECTION_STATE,
	}
}

export const setProfilePictureAction = (
	payload?: SupportedProfilePictureAction
) => {
	return {
		type: ActionStates.SET_PROFILE_PICTURE_ACTION,
		payload,
	}
}

export const showSubmitButtonLoader = (payload: boolean) => {
	return {
		type: ActionStates.DISPLAY_SUBMIT_BUTTON_LOADER,
		payload,
	}
}

export const setSubmitState = (isSubmitting: boolean) => {
	return {
		type: ActionStates.SUBMIT_STATE,
		payload: isSubmitting,
	}
}

export const updateCroppedState = (payload: Partial<FileInfoType>) => {
	return {
		type: ActionStates.UPDATE_CROPPED_STATE,
		payload: payload,
	}
}

export const updateAvatarState = (avatarPayload: FileInfoType) => {
	return {
		type: ActionStates.UPDATE_AVATAR_FILE_STATE,
		payload: avatarPayload,
	}
}

export const setAppConfig = (config: Config) => {
	return {
		type: ActionStates.UPDATE_APP_CONFIG,
		payload: config,
	}
}

export const setMarketingCompanyType = (payload: Record<string, boolean>) => {
	return {
		type: ActionStates.SET_MARKETING_COMPANY_TYPE,
		payload: payload,
	}
}
